import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
} from "reactstrap";
import fireExtinguisher from "../../images/buildings/fire-extinguisher-.svg";
import policy from "../../images/buildings/policy.svg";
import solarEnergy from "../../images/buildings/solar-energy.svg";
import stairs from "../../images/buildings/stairs.svg";
import contractNoc from "../../images/buildings/contract.svg";
import { Label, FormGroup } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import ErrorComponents from "../errorComponents/ErrorComponents";
import axios from "axios";
import { environment, S3_BUCKET, myBucket, BuildingLink } from "../../env";
import {
  getBuildingAction,
  getProjectAction,
  linkRedirectAction,
  loaderAction,
  successInfoAction,
  successModalToggle,
} from "../../redux/actions/Index";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import { ToWords } from 'to-words';
import DocumentsCard from './../DocumentsCard/DocumentsCard';
import { PencilLine } from '@phosphor-icons/react';
import TitleCase from "../../Helper/TitleCase";
import { toast } from "react-toastify";


function BuildingModal(props) {
  // ---------List of useState-------------------------------------------------------
  const [modal, setModal] = useState(false);
  const [btndis, setBtndis] = useState(true);
  const [errormessage, setErrormessage] = useState();
  const [toi, setToi] = useState(false);
  const [showfire, setShowfire] = useState(false);
  const [sstability, setShowstability] = useState(false);
  const [ssolarpower, setShowsolar] = useState(false);
  const [smazanine, setShowmazanine] = useState(false);
  const [snoc, setShownoc] = useState(false);
  const [selectricity, setShowElectricity] = useState(false);
  const [date_of_completion, setDateOfCompletion] = useState();
  const [carpetErrorMessage, setCarpetErrorMessage] = useState();
  const [yearsBetween, setYearsBetween] = useState(0);
  const [monthsBetween, setMonthsBetween] = useState(0);
  const [daysBetween, setDaysBetween] = useState(0);
  const [builddocs, setBuilddocs] = useState([])
  const [totalbuildingbuiltupLabel, settotalbuildingbuiltupLabel] = useState();
  const toWords = new ToWords();

  // --------------------------------------------------------------------------------

  // -----------------------------------List of Redux State-----------------------------
  const projectList = useSelector((state) => state?.ModalReducer?.projectList);
  const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
  const permissiontype = useSelector((state) => state?.ModalReducer?.permissiontype);
  const buildingtype = useSelector((state) => state?.ModalReducer?.buildingtypes);
  const floorType = useSelector((state) => state?.ModalReducer?.floorType);
  const electricityconnection = useSelector((state) => state?.ModalReducer?.electricityconnection);
  const watersupply = useSelector((state) => state?.ModalReducer?.watersupply);
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);
  // --------------------------------------------------------------------------------

  const toggle = () => { setModal(!modal), settotalbuildingbuiltupLabel() }
  const dispatch = useDispatch();

  const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm();


  const CancelButton = () => {
    toggle();
    reset();
    setBtndis(true);
    setDateOfCompletion();
  };

  // var selectedProjectId = watch("project");
  var selectedAreaBuiltup = watch("area_builtup");
  var floorCapacity = watch("floor_capacity");
  var carpetArea = watch("area_carpet");
  var toilet = watch("toilet");
  var firesystem = watch("fire_system")
  var firesystemdocument = watch("fire_system_document")
  var solarpowerdocument = watch("solar_power_document")
  var stabilitycertificatedocument = watch("stability_certificate_document")
  var mazaninefacilitydocument = watch("mazanine_facility_document")
  var nocdocument = watch("noc_document")
  var mazanine_facility = watch("mazanine_facility")
  var noc = watch("noc")
  var electricity = watch("electricity")
  var electricitydoc = watch('electricity_document')
  var stability_certificate = watch("stability_certificate")
  var solar_power = watch("solar_power")

  const getProjectData = () => {
    try {
      axios.get(`${environment.baseUrl}project/`).then(res => {
        let data = res.data;
        dispatch(getProjectAction(data));

      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };
  const getBuildingData = () => {
    try {
      axios.get(`${environment.baseUrl}building/`).then(res => {
        let filData = res.data?.filter((data) => data.project.id == userProject)
        dispatch(getBuildingAction(filData));

      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  useMemo(() => {
    setShowfire(firesystem);
    setShownoc(noc);
    setShowsolar(solar_power);
    setShowstability(stability_certificate);
    setShowmazanine(mazanine_facility);
    setShowElectricity(electricity)
  }, [firesystem, noc, mazanine_facility, stability_certificate, solar_power, electricity])

  const documenturl = async (data) => {
    var date = Math.round(+new Date() / 1000);
    const params = {
      ACL: "public-read",
      Body: data,
      Bucket: S3_BUCKET,
      Key: `${date}_${data.name}`,
    };
    myBucket.upload(params, function (err, uploadData) {
      if (uploadData) {
        data = uploadData.Location;
        return (data);
      } else {
        console.log("error", err);
      }
    });
  }

  const autoAreaCarpet = () => {
    if (selectedAreaBuiltup) {
      setValue('area_carpet', (selectedAreaBuiltup / 1.25).toFixed(2))
    }
  }

  const CreateSubmit = async (data) => {
    var date = Math.round(+new Date() / 1000);
    dispatch(loaderAction());
    data.date_of_completion = moment(data?.date_of_completion).format('YYYY-MM-DD')
    const building_payload = new FormData();
    building_payload.append("project", userProject);
    building_payload.append("building_no", data?.building_no);
    building_payload.append("building_type", data?.building_type);
    building_payload.append("floor_capacity", data?.floor_capacity);
    building_payload.append("floor_type", data?.floor_type);
    building_payload.append("center_height", data?.center_height);
    building_payload.append("side_height", data?.side_height);
    building_payload.append("area_builtup", data?.area_builtup);
    building_payload.append("area_carpet", data?.area_carpet);
    building_payload.append("no_of_gala", data?.no_of_gala);
    building_payload.append("dock", data?.dock);
    building_payload.append("shutter", data?.shutter);
    building_payload.append("sliding_ramp", data?.sliding_ramp);
    building_payload.append("auto_dock", data?.auto_dock);
    building_payload.append("permission_type", data?.permission_type);
    building_payload.append("water_supply", data?.water_supply);
    building_payload.append("available_area", data?.area_builtup);
    building_payload.append("toilet", data?.toilet);
    building_payload.append("in_side_length_l", data?.in_side_length_l);
    building_payload.append("in_side_length_r", data?.in_side_length_r);
    building_payload.append("out_side_length_r", data?.out_side_length_r);
    building_payload.append("out_side_length_l", data?.out_side_length_l);
    building_payload.append("front_side_length", data?.front_side_length);
    building_payload.append("building_age", data?.building_age);
    building_payload.append("no_of_light", data?.no_of_light);
    building_payload.append("electricity_connection", data?.electricity_connection);
    building_payload.append("service_no", data?.service_no);
    building_payload.append("electricity_deposit", data?.electricity_deposit);
    building_payload.append("meter_owner", data?.meter_owner);
    if (toilet == "yes") {
      building_payload.append("no_of_toilet", data?.no_of_toilet);
    } else {
      building_payload.append("no_of_toilet", 0);
    }
    building_payload.append("survey_no", data?.survey_no);
    building_payload.append("date_of_completion", data?.date_of_completion);
    building_payload.append(
      "total_area_of_project",
      data?.total_area_of_project
    );
    building_payload.append("village_name", data?.village_name);
    if (data?.fire_system == undefined || data?.fire_system == false) {
      building_payload.append("fire_system", false);
      building_payload.append("fire_system_document", "No Document Uploaded");
    } else {
      let files = []
      Array.from(data?.fire_system_document).forEach(async (file) => {
        files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
        await documenturl(file)
      })
      building_payload.append("fire_system", data?.fire_system);
      building_payload.append("fire_system_comment", data?.fire_system_comment);
      building_payload.append("fire_system_document", JSON.stringify(files));
    }

    if (data?.mazanine_facility == undefined || data?.mazanine_facility == false) {
      building_payload.append("mazanine_facility", false);
      building_payload.append("mazanine_facility_document", "No Document Uploaded");
    } else {
      let files = []
      Array.from(data?.mazanine_facility_document).forEach(async (file) => {
        files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
        await documenturl(file)
      })
      building_payload.append("mazanine_facility", data?.mazanine_facility);
      building_payload.append("mazanine_comment", data?.mazanine_comment);
      building_payload.append("mazanine_facility_document", JSON.stringify(files));
    }
    if (data?.noc == undefined || data?.noc == false) {
      building_payload.append("noc", false);
      building_payload.append("noc_document", "No Document Uploaded");
    } else {
      let files = []
      Array.from(data?.noc_document).forEach(async (file) => {
        files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
        await documenturl(file)
      })
      building_payload.append("noc", data?.noc);
      building_payload.append("noc_comment", data?.noc_comment);
      building_payload.append("noc_document", JSON.stringify(files));
    }
    if (data?.solar_power == undefined || data?.solar_power == false) {
      building_payload.append("solar_power", false);
      building_payload.append("solar_power_document", "No Document Uploaded");
    } else {
      let files = []
      Array.from(data?.solar_power_document).forEach(async (file) => {
        files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
        await documenturl(file)
      })
      building_payload.append("solar_power", data?.solar_power);
      building_payload.append("solar_comment", data?.solar_comment);
      building_payload.append("solar_power_document", JSON.stringify(files));
    }
    if (data?.stability_certificate == undefined || data?.stability_certificate == false) {
      building_payload.append("stability_certificate", false);
      building_payload.append("stability_certificate_document", "No Document Uploaded");
    } else {
      let files = []
      Array.from(data?.stability_certificate_document).forEach(async (file) => {
        files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
        await documenturl(file)
      })
      building_payload.append("stability_certificate", data?.stability_certificate);
      building_payload.append("stability_comment", data?.stability_comment);
      building_payload.append("stability_certificate_document", JSON.stringify(files));
    }
    if (data?.electricity == undefined || data?.electricity == false) {
      building_payload.append("electricity", false);
      building_payload.append("electricity_document", "No Document Uploaded");
    } else {
      let files = []
      Array.from(data?.electricity_document).forEach(async (file) => {
        files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
        await documenturl(file)
      })
      building_payload.append("electricity", data?.electricity);
      building_payload.append("electricity_comment", data?.electricity_comment);
      building_payload.append("electricity_document", JSON.stringify(files));
    }
    try {
      await axios
        .post(`${environment.baseUrl}building/`, building_payload)
        .then((form) => {
          if (form.data.code === 200) {
            dispatch(successModalToggle());
            dispatch(linkRedirectAction('/Gala'))
            dispatch(successInfoAction("Building created successfully, Now create gala"))
            getBuildingData();
            getProjectData();
            toggle();
            reset();
            setDateOfCompletion();
            setBtndis(true);
            dispatch(loaderAction());
          } else if (form.data.code === 5005) {
            dispatch(loaderAction());
            setBtndis(true);
            toast.error(form.data.message, {
              position: toast.POSITION.TOP_CENTER
            });
          } else {
            dispatch(loaderAction());
            setBtndis(true);
          }
        });
    } catch (err) {
      setBtndis(true);
      dispatch(loaderAction());
      console.log(err);
    }
  };

  const EditSubmit = async (data) => {
    var date = Math.round(+new Date() / 1000);
    dispatch(loaderAction());
    setBtndis(false);
    const building_payload = new FormData();
    building_payload.append("project", userProject);
    building_payload.append("building_no", data?.building_no);
    building_payload.append("building_type", data?.building_type);
    building_payload.append("floor_type", data?.floor_type);
    building_payload.append("floor_capacity", data?.floor_capacity);
    building_payload.append("center_height", data?.center_height);
    building_payload.append("side_height", data?.side_height);
    building_payload.append("area_builtup", data?.area_builtup);
    building_payload.append("area_carpet", data?.area_carpet);
    building_payload.append("no_of_gala", data?.no_of_gala);
    building_payload.append("dock", data?.dock);
    building_payload.append("shutter", data?.shutter);
    building_payload.append("sliding_ramp", data?.sliding_ramp);
    building_payload.append("auto_dock", data?.auto_dock);
    building_payload.append("in_side_length_l", data?.in_side_length_l);
    building_payload.append("in_side_length_r", data?.in_side_length_r);
    building_payload.append("out_side_length_l", data?.out_side_length_l);
    building_payload.append("out_side_length_r", data?.out_side_length_r);
    building_payload.append("permission_type", data?.permission_type);
    building_payload.append("water_supply", data?.water_supply);
    building_payload.append("toilet", data?.toilet);
    building_payload.append("front_side_length", data?.front_side_length);
    building_payload.append("building_age", data?.building_age);
    building_payload.append("no_of_light", data?.no_of_light);
    building_payload.append("electricity_connection", data?.electricity_connection);
    building_payload.append("service_no", data?.service_no);
    building_payload.append("electricity_deposit", data?.electricity_deposit);
    building_payload.append("meter_owner", data?.meter_owner);
    if (toilet == "yes") {
      building_payload.append("no_of_toilet", data?.no_of_toilet);
    } else {
      building_payload.append("no_of_toilet", 0);
    }
    building_payload.append("survey_no", data?.survey_no);
    building_payload.append("date_of_completion", data?.date_of_completion);
    building_payload.append("total_area_of_project", data?.total_area_of_project);
    building_payload.append("village_name", data?.village_name);
    if (data?.fire_system == undefined || data?.fire_system == false) {
      building_payload.append("fire_system", false);
      building_payload.append("fire_system_document", "No Document Uploaded");
    } else {
      let files = []
      if (props?.data?.fire_system_document != "No Document Uploaded") {
        builddocs.map((doc) => {
          if (doc.documentname == 'fire_system_document') {
            doc.documenturl.map((url) => {
              files.push(url)
            })
          }
        }
        )
        if (data?.fire_system_document.length != 0) {
          Array.from(data?.fire_system_document).forEach(async (file) => {
            files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
            await documenturl(file)
          })
        }
      }
      else {
        Array.from(data?.fire_system_document).forEach(async (file) => {
          files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
          await documenturl(file)
        })
      }
      let flag = false
      files.map(file => {
        if (file.view == 0) {
          flag = true
        }
      })
      if (flag == false) {
        building_payload.append("fire_system", false);
      } else {
        building_payload.append("fire_system", data?.fire_system);
      }
      building_payload.append("fire_system_comment", data?.fire_system_comment);
      building_payload.append("fire_system_document", JSON.stringify(files))
    }
    if (data?.mazanine_facility == undefined || data?.mazanine_facility == false) {
      building_payload.append("mazanine_facility", false);
      building_payload.append("mazanine_facility_document", "No Document Uploaded");
    } else {
      let files = []
      if (props?.data?.mazanine_facility_document != "No Document Uploaded") {
        builddocs.map((doc) => {
          if (doc.documentname == 'mazanine_facility_document') {
            doc.documenturl.map((url) => {
              files.push(url)
            })
          }
        }
        )
        if (data?.mazanine_facility_document.length != 0) {
          Array.from(data?.mazanine_facility_document).forEach(async (file) => {
            files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
            await documenturl(file)
          })
        }
      }
      else {
        Array.from(data?.mazanine_facility_document).forEach(async (file) => {
          files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
          await documenturl(file)
        })
      }
      let flag = false
      files.map(file => {
        if (file.view == 0) {
          flag = true
        }
      })
      if (flag == false) {
        building_payload.append("mazanine_facility", false);
      } else {
        building_payload.append("mazanine_facility", data?.mazanine_facility);
      }
      building_payload.append("mazanine_comment", data?.mazanine_comment);
      building_payload.append("mazanine_facility_document", JSON.stringify(files))
    }
    if (data?.noc == undefined || data?.noc == false) {
      building_payload.append("noc", false);
      building_payload.append("noc_document", "No Document Uploaded");
    } else {
      let files = []
      if (props?.data?.noc_document != "No Document Uploaded") {
        builddocs.map((doc) => {
          if (doc.documentname == 'noc_document') {
            doc.documenturl.map((url) => {
              files.push(url)
            })
          }
        }
        )
        if (data?.noc_document.length != 0) {
          Array.from(data?.noc_document).forEach(async (file) => {
            files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
            await documenturl(file)
          })
        }
      }
      else {
        Array.from(data?.noc_document).forEach(async (file) => {
          files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
          await documenturl(file)
        })
      }
      let flag = false
      files.map(file => {
        if (file.view == 0) {
          flag = true
        }
      })
      if (flag == false) {
        building_payload.append("noc", false);
      } else {
        building_payload.append("noc", data?.noc);
      }
      building_payload.append("noc_comment", data?.noc_comment);
      building_payload.append("noc_document", JSON.stringify(files))
    }
    if (data?.solar_power == undefined || data?.solar_power == false) {
      building_payload.append("solar_power", false);
      building_payload.append("solar_power_document", "No Document Uploaded");
    } else {
      let files = []
      if (props?.data?.solar_power_document != "No Document Uploaded") {
        builddocs.map((doc) => {
          if (doc.documentname == 'solar_power_document') {
            doc.documenturl.map((url) => {
              files.push(url)
            })
          }
        }
        )
        if (data?.solar_power_document.length != 0) {
          Array.from(data?.solar_power_document).forEach(async (file) => {
            files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
            await documenturl(file)
          })
        }
      }
      else {
        Array.from(data?.solar_power_document).forEach(async (file) => {
          files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
          await documenturl(file)
        })
      }
      let flag = false
      files.map(file => {
        if (file.view == 0) {
          flag = true
        }
      })
      if (flag == false) {
        building_payload.append("solar_power", false);
      } else {
        building_payload.append("solar_power", data?.solar_power);
      }
      building_payload.append("solar_comment", data?.solar_comment);
      building_payload.append("solar_power_document", JSON.stringify(files))
    }
    if (data?.stability_certificate == undefined || data?.stability_certificate == false) {
      building_payload.append("stability_certificate", false);
      building_payload.append("stability_certificate_document", "No Document Uploaded");
    } else {
      let files = []
      if (props?.data?.stability_certificate_document != "No Document Uploaded") {
        builddocs.map((doc) => {
          if (doc.documentname == 'stability_certificate_document') {
            doc.documenturl.map((url) => {
              files.push(url)
            })
          }
        }
        )
        if (data?.stability_certificate_document.length != 0) {
          Array.from(data?.stability_certificate_document).forEach(async (file) => {
            files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
            await documenturl(file)
          })
        }
      }
      else {
        Array.from(data?.stability_certificate_document).forEach(async (file) => {
          files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
          await documenturl(file)
        })
      }
      let flag = false
      files.map(file => {
        if (file.view == 0) {
          flag = true
        }
      })
      if (flag == false) {
        building_payload.append("stability_certificate", false);
      } else {
        building_payload.append("stability_certificate", data?.stability_certificate);
      }
      building_payload.append("stability_comment", data?.stability_comment);
      building_payload.append("stability_certificate_document", JSON.stringify(files))
    }

    if (data?.electricity == undefined || data?.electricity == false) {
      building_payload.append("electricity", false);
      building_payload.append("electricity_document", "No Document Uploaded");
    } else {
      let files = []
      if (props?.data?.electricity_document != "No Document Uploaded") {
        builddocs.map((doc) => {
          if (doc.documentname == 'electricity_document') {
            doc.documenturl.map((url) => {
              files.push(url)
            })
          }
        }
        )
        if (data?.electricity_document.length != 0) {
          Array.from(data?.electricity_document).forEach(async (file) => {
            files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
            await documenturl(file)
          })
        }
      }
      else {
        Array.from(data?.electricity_document).forEach(async (file) => {
          files.push({ url: `${BuildingLink}${date}_${file.name}`, view: 0 })
          await documenturl(file)
        })
      }
      let flag = false
      files.map(file => {
        if (file.view == 0) {
          flag = true
        }
      })
      if (flag == false) {
        building_payload.append("electricity", false);
      } else {
        building_payload.append("electricity", data?.electricity);
      }
      building_payload.append("electricity_comment", data?.electricity_comment);
      building_payload.append("electricity_document", JSON.stringify(files))
    }
    try {
      await axios
        .put(`${environment.baseUrl}editbuilding/${props?.data?.id}`, building_payload)
        .then((form) => {
          if (form.data.code === 200) {
            dispatch(loaderAction());
            dispatch(successModalToggle());
            getBuildingData();
            getProjectData();
            reset(data);
            toggle();
            setBtndis(true);
          }
          else if (form.data.code == 5005) {
            setBtndis(true);
            dispatch(loaderAction());
            toast.error(form.data.message, {
              position: toast.POSITION.TOP_CENTER
            });
          }
        });
    } catch (err) {
      setBtndis(true);
      dispatch(loaderAction());
      console.log(err);
    }
  };

  const currentDate = moment(new Date()).format('YYYY-MM-DD');

  useEffect(() => {
    if (props.button == "create") {
      reset({ 'created_at': currentDate });
    }
    else {
      reset({
        "project": props?.data?.project?.id,
        "building_no": props?.data?.building_no,
        "building_type": props?.data?.building_type?.id,
        "floor_type": props?.data?.floor_type?.id,
        "floor_capacity": props?.data?.floor_capacity,
        "center_height": props?.data?.center_height,
        "side_height": props?.data?.side_height,
        "area_builtup": props?.data?.area_builtup,
        "area_carpet": props?.data?.area_carpet,
        "no_of_gala": props?.data?.no_of_gala,
        "dock": props?.data?.dock,
        "shutter": props?.data?.shutter,
        "sliding_ramp": props?.data?.sliding_ramp,
        "auto_dock": props?.data?.auto_dock,
        "in_side_length_l": props?.data?.in_side_length_l,
        "in_side_length_r": props?.data?.in_side_length_r,
        "out_side_length_l": props?.data?.out_side_length_l,
        "out_side_length_r": props?.data?.out_side_length_r,
        "permission_type": props?.data?.permission_type,
        "water_supply": props?.data?.water_supply,
        "toilet": props?.data?.toilet,
        "front_side_length": props?.data?.front_side_length,
        "building_age": props?.data?.building_age,
        "no_of_light": props?.data?.no_of_light,
        "electricity_connection": props?.data?.electricity_connection,
        "service_no": props?.data?.service_no,
        "electricity_deposit": props?.data?.electricity_deposit,
        "meter_owner": props?.data?.meter_owner,
        "no_of_toilet": props?.data?.no_of_toilet,
        "survey_no": props?.data?.survey_no,
        "date_of_completion": props?.data?.date_of_completion?.split("T")[0],
        "total_area_of_project": props?.data?.total_area_of_project,
        "village_name": props?.data?.village_name?.id,
        "fire_system": props?.data?.fire_system,
        "mazanine_facility": props?.data?.mazanine_facility,
        "noc": props?.data?.noc,
        "solar_power": props?.data?.solar_power,
        "stability_certificate": props?.data?.stability_certificate,
        "electricity": props?.data?.electricity,
        "fire_system_comment": props?.data?.fire_system_comment,
        "stability_comment": props?.data?.stability_comment,
        "solar_comment": props?.data?.solar_comment,
        "noc_comment": props?.data?.noc_comment,
        "mazanine_comment": props?.data?.mazanine_comment,
        "electricity_comment": props?.data?.electricity_comment,
      });
      let arr = []
      if (props?.data?.fire_system_document != 'No Document Uploaded' && props?.data?.fire_system_document != undefined) {
        let firedocs = JSON.parse(props?.data?.fire_system_document).filter(doc => doc.view == 0)
        if (firedocs?.length > 0) {
          arr.push({ documentname: "fire_system_document", documenturl: firedocs })
        }
      }
      if (props?.data?.mazanine_facility_document != 'No Document Uploaded' && props?.data?.mazanine_facility_document != undefined) {
        let mdocs = JSON.parse(props?.data?.mazanine_facility_document).filter(doc => doc.view == 0)
        if (mdocs?.length > 0) {
          arr.push({ documentname: "mazanine_facility_document", documenturl: mdocs })
        }
      }
      if (props?.data?.noc_document != 'No Document Uploaded' && props?.data?.noc_document != undefined) {
        let docs = JSON.parse(props?.data?.noc_document).filter(doc => doc.view == 0)
        if (docs?.length > 0) {
          arr.push({ documentname: "noc_document", documenturl: docs })
        }
      }
      if (props?.data?.solar_power_document != 'No Document Uploaded' && props?.data?.solar_power_document != undefined) {
        let docs = JSON.parse(props?.data.solar_power_document).filter(doc => doc.view == 0)
        if (docs?.length > 0) {
          arr.push({ documentname: "solar_power_document", documenturl: docs })
        }
      }
      if (props?.data?.stability_certificate_document != 'No Document Uploaded' && props?.data?.stability_certificate_document != undefined) {
        let docs = JSON.parse(props?.data.stability_certificate_document).filter(doc => doc.view == 0)
        if (docs?.length > 0) {
          arr.push({ documentname: "stability_certificate_document", documenturl: docs })
        }
      }
      if (props?.data?.electricity_document != 'No Document Uploaded' && props?.data?.electricity_document != undefined) {
        let docs = JSON.parse(props?.data.electricity_document).filter(doc => doc.view == 0)
        if (docs?.length > 0) {
          arr.push({ documentname: "electricity_document", documenturl: docs })
        }
      }
      setBuilddocs(arr)
    }
  }, []);

  useMemo(() => {
    if (date_of_completion) {
      const currentDate = moment(new Date()).format('YYYY-MM-DD');
      const CompleteDate = moment(date_of_completion).format('YYYY-MM-DD')
      var date1 = moment(currentDate);
      var date2 = moment(CompleteDate);
      var days = date1.diff(date2, 'days')
      let years = date1.diff(date2, 'year');
      date2.add(years, 'years');
      let months = date1.diff(date2, 'months');
      date2.add(months, 'months');
      days = date1.diff(date2, 'days');
      date2.add(days, 'days');
      setYearsBetween(years);
      setMonthsBetween(months);
      setDaysBetween(days);
    }
  }, [date_of_completion, yearsBetween, daysBetween, monthsBetween]);

  useMemo(() => {
    if (userProject) {
      const selectedProjectDetails = projectList?.filter(
        (projects) => projects.id == userProject
      );
      const availableArea = selectedProjectDetails?.[0]?.total_area_of_project - selectedProjectDetails?.[0]?.occupied_area
      var projectBuilding = buildingList?.filter(
        (filterBuilding) => filterBuilding.project.id == userProject
      );
      const bldgBuiltUpAreaCalc = projectBuilding?.reduce(
        (a, b) => a + parseFloat(b.area_builtup),
        0
      );
      const totalbuildingbuiltup =
        selectedProjectDetails?.[0]?.total_area_of_project -
        bldgBuiltUpAreaCalc;

      settotalbuildingbuiltupLabel(availableArea)
      if (props?.button == 'create') {
        if (selectedAreaBuiltup > parseInt(availableArea)) {
          setErrormessage(
            `${selectedAreaBuiltup} is greater then ${Number(availableArea).toFixed(2)} `
          );
        } else {
          setErrormessage("");
        }
      } else {
        const availableArea1 = Number(availableArea) + Number(props?.data?.area_builtup)
        if (selectedAreaBuiltup > parseInt(availableArea1)) {
          setErrormessage(
            `${selectedAreaBuiltup} is greater then ${availableArea} `
          );
        } else {
          setErrormessage("");
        }
      }
    }
  }, [userProject, selectedAreaBuiltup, buildingList, projectList]);

  useMemo(() => {
    if (Number(carpetArea) > Number(selectedAreaBuiltup)) {
      setCarpetErrorMessage(
        `${carpetArea} is greater than built-up area ${selectedAreaBuiltup}`
      );
      setBtndis(false)
    } else {
      setCarpetErrorMessage("");
      setBtndis(true)
    }
  }, [carpetArea, selectedAreaBuiltup]);
  useMemo(() => {
    if (toilet == "yes") {
      setToi(true);
    } else {
      setToi(false);
    }
  }, [toilet]);

  const handleDocument = (file) => {
    let arr = [];
    builddocs.map(doc => {
      arr.push(doc);
    })
    arr.map((doc, i) => {
      let index = i
      if (doc?.documentname == file?.documentname) {

        doc.documenturl.map((url, i) => {
          if (url.url == file.documenturl) {
            url.view = 1
          }
        })
      }
    })
    setBuilddocs(arr)
  }

  const numaricAndSymbol = (inputString) => {
    const match = inputString.match(/[0-9!@#$%^&*`~+=;,?":/\\[\]{}|<>]/);
    return match ? true: false;
  }

  const isAlphaHandeler = (event) => {
    event.preventDefault();
    let tempString = event.target.value;
    let numberOccurance = tempString.length;
    for(let i=0;i< tempString.length;i++){
      if(numaricAndSymbol(tempString[i])){
        numberOccurance = i;
        break;
      }
    }

    tempString = tempString.substring(0,numberOccurance);

    tempString = tempString.toLowerCase().split(' ').map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
    setValue('meter_owner', tempString)
  }


  return (
    <>
      {props.button == "create" ? (
        <Button
          onClick={toggle}
          className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5"
        >
          <span className="fs-3 d-flex gap-3 title-font-600 px-3">
            Create Building
          </span>
        </Button>
      ) : (
        <button
          onClick={toggle}
          className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' />
        </button>
      )}
      <Modal
        className="border-0"
        isOpen={modal}
        toggle={props.toggle}
        size="xl"
        centered
      >
        <ModalHeader className="bg-base-color py-4" toggle={props.toggle}>
          <span className="title-font-700 fs-36 text-base-white">
            {props.button == "create"
              ? "Create New Building"
              : `Edit ${props?.data?.building_no} Building`}
          </span>
        </ModalHeader>
        <Form
          onSubmit={
            props.button == "create"
              ? handleSubmit(CreateSubmit)
              : handleSubmit(EditSubmit)
          }
        >
          <ModalBody className="bg-background-color px-5 pb-5 pt-3">
            <div className="row flex-wrap">
              {/* <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Projects *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="project"
                    disabled={props.button != 'create'}
                    name="project"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("project", { required: true })}
                  >
                    <option value="">Select Project</option>
                    {projectList?.map((project, i) => {
                      return <option value={project.id} key={i}>{project.name}</option>;
                    })}
                  </select>
                </div>
                {errors.project && (
                  <ErrorComponents error={"Project name is required *"} />
                )}
                <br />
              </div> */}
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Building No *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input text-uppercase"
                    type="text"
                    placeholder="Enter Building number...."
                    {...register("building_no", { required: true, onChange: (e) => { e.target.value = e.target.value.toUpperCase() } })}
                  />
                </div>
                {errors.building_no && (
                  <ErrorComponents error={"Building number is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Construct Type *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="building_type"
                    name="building_type"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("building_type", { required: true })}
                  >
                    <option value="">Select Construct Type</option>
                    {buildingtype?.map((type, i) => {
                      return <option value={type.id} key={i}>{type.name}</option>;
                    })}
                  </select>
                </div>
                {errors.building_type && (
                  <ErrorComponents error={"Building number is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  No of Gala *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeValues}
                    placeholder="No of gala 1,2,3..."
                    {...register("no_of_gala", { required: true })}
                  />
                </div>
                {errors.no_of_gala && (
                  <ErrorComponents error={"Gala is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Center Height *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <div className="numberTextSuffixfeets w-100">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="number"
                      min={0}
                      step="any"
                      onKeyDown={preventNegativeValues}
                      placeholder="Enter Center Height..."
                      {...register("center_height", { required: true })}
                    />
                  </div>
                </div>
                {errors.center_height && (
                  <ErrorComponents error={"Center height is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Side Height *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <div className="numberTextSuffixfeets w-100">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="number"
                      min={0}
                      step="any"
                      onKeyDown={preventNegativeValues}
                      placeholder="Enter Side Height..."
                      {...register("side_height", { required: true })}
                    />
                  </div>
                </div>
                {errors.side_height && (
                  <ErrorComponents error={"Side height is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Area Builtup *
                  {totalbuildingbuiltupLabel > -1 &&
                    <span className="fs-4 text-base-black ps-1 base-font-bold">({Number(totalbuildingbuiltupLabel).toFixed(2)}) Sq.ft</span>}
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <div className="numberTextSuffix w-100">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="number"
                      min={0}
                      step="any"
                      onKeyDown={preventNegativeValues}
                      placeholder="Area Builtup..."
                      {...register("area_builtup", {
                        required: "Builtup area is required *",
                        onBlur: autoAreaCarpet
                      })}
                    />
                  </div>
                </div>
                {
                  selectedAreaBuiltup &&
                  <>
                    <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(selectedAreaBuiltup)}</span></small>
                    <br />
                  </>
                }
                {errors.area_builtup && (
                  <ErrorComponents error={"Builtup area is required *"} />
                )}
                {errormessage && <ErrorComponents error={errormessage} />}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Area Carpet *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <div className="numberTextSuffix w-100">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="number"
                      min={0}
                      step="any"
                      onKeyDown={preventNegativeValues}
                      placeholder="Area Carpet..."
                      {...register("area_carpet", { required: true })}
                    />
                  </div>
                </div>
                {
                  carpetArea &&
                  <>
                    <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(carpetArea)}</span></small>
                    <br />
                  </>
                }
                {errors.area_carpet && (
                  <ErrorComponents error={"Area carpet is required *"} />
                )}
                {carpetErrorMessage && (
                  <ErrorComponents error={carpetErrorMessage} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Dock *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeValues}
                    placeholder="Dock...."
                    {...register("dock", { required: true })}
                  />
                </div>
                {errors.dock && <ErrorComponents error={"Dock is required *"} />}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Auto Dock *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeValues}
                    placeholder="Auto Dock..."
                    {...register("auto_dock", { required: true })}
                  />
                </div>
                {errors.auto_dock && (
                  <ErrorComponents error={"Auto dock is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Floor Type *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="Floor_Type"
                    name="role_type"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("floor_type", { required: true })}
                  >
                    <option value="">Select Floor Type</option>
                    {floorType?.map((floor, i) => {
                      return (
                        <option value={floor.id} key={i}>{floor.name}</option>
                      );
                    })}
                  </select>
                </div>
                {errors.water_supply && (
                  <ErrorComponents error={"Floor Type is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Floor Load Capacity *
                </Label>
                <br />
                <div className="numberTextSuffixtons">
                  <div className="mt-1  d-flex gap-3">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="number"
                      min={0}
                      step="any"
                      onKeyDown={preventNegativeValues}
                      placeholder="Floor Load...."
                      {...register("floor_capacity", { required: true })}
                    />
                  </div>
                </div>
                {
                  floorCapacity &&
                  <>
                    <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(floorCapacity)}</span></small>
                    <br />
                  </>
                }
                {errors.floor_capacity && <ErrorComponents error={"Floor Load is required *"} />}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Shutter *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeValues}
                    placeholder="Shutter....."
                    {...register("shutter", { required: true })}
                  />
                </div>
                {errors.shutter && (
                  <ErrorComponents error={"Shutter is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Sliding Ramp *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeValues}
                    placeholder="Sliding Ramp..."
                    {...register("sliding_ramp", { required: true })}
                  />
                </div>
                {errors.sliding_ramp && (
                  <ErrorComponents error={"Sliding ramp is required *"} />
                )}
                <br />
              </div>

              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Front Side Road *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <div className="numberTextSuffixfeets w-100">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="number"
                      min={0}
                      step="any"
                      onKeyDown={preventNegativeValues}
                      placeholder="Front Side Road..."
                      {...register("front_side_length", { required: true })}
                    />
                  </div>
                </div>
                {errors.front_side_length && (
                  <ErrorComponents error={"Front side road is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  In-Side Length *
                </Label>
                <br />
                <div className="row">
                  <div className="mt-1 col-5">
                    <div className="numberTextSuffixfeets">
                      <input
                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                        type="number"
                        min={0}
                        step="any"
                        onKeyDown={preventNegativeValues}
                        placeholder="width..."
                        {...register("in_side_length_l", { required: true })}
                      />
                    </div>
                    {errors.in_side_length_l && (
                      <ErrorComponents error={"Width is required *"} />
                    )}
                  </div>
                  <br />
                  <span className="col-1 crossArrow"><i className='bx bx-x bx-flashing fs-1 text-base-color' ></i></span>
                  <div className="mt-1  col-5">
                    <div className="numberTextSuffixfeets">
                      <input
                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                        type="number"
                        min={0}
                        step="any"
                        onKeyDown={preventNegativeValues}
                        placeholder="Height..."
                        {...register("in_side_length_r", { required: true })}
                      />
                    </div>
                    {errors.in_side_length_r && (
                      <ErrorComponents error={"Height is required *"} />
                    )}
                  </div>
                  <br />
                </div>
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Out-Side Length *
                </Label>
                <br />
                <div className="row">
                  <div className="mt-1   col-5">
                    <div className="numberTextSuffixfeets">
                      <input
                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                        type="number"
                        min={0}
                        step="any"
                        onKeyDown={preventNegativeValues}
                        placeholder="width..."
                        {...register("out_side_length_l", { required: true })}
                      />
                    </div>

                    {errors.out_side_length_l && (
                      <ErrorComponents error={"Width is required *"} />
                    )}
                  </div>
                  <br />
                  <span className="col-1 crossArrow"><i className='bx bx-x bx-flashing fs-1 text-base-color' ></i></span>
                  <div className="mt-1   col-5">
                    <div className="numberTextSuffixfeets">
                      <input
                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                        type="number"
                        min={0}
                        step="any"
                        onKeyDown={preventNegativeValues}
                        placeholder="Height..."
                        {...register("out_side_length_r", { required: true })}
                      />
                    </div>
                    {errors.out_side_length_r && (
                      <ErrorComponents error={"Height is required *"} />
                    )}
                  </div>
                </div>
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Permission Type *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="role_type"
                    name="role_type"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("permission_type", { required: true })}
                  >
                    <option value="">Select Permission Type</option>
                    {permissiontype?.map((data, i) => {
                      return <option value={data.permission_type} key={i}>{data.permission_type}</option>;
                    })}
                  </select>
                </div>
                {errors.permission_type && (
                  <ErrorComponents error={"Permission Type is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Water Supply *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="water_supply"
                    name="role_type"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("water_supply", { required: true })}
                  >
                    <option value="">Select Water Supply</option>
                    {watersupply?.map((water, i) => {
                      return (
                        <option value={water.water_supply} key={i}>{water.water_supply}</option>
                      );
                    })}
                  </select>
                </div>
                {errors.water_supply && (
                  <ErrorComponents error={"No of water_supply is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Toilet *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="toilet"
                    name="role_type"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("toilet", { required: true })}
                  >
                    <option value="" >
                      Select Toilet Status
                    </option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                {errors.toilet && (
                  <ErrorComponents error={"Toilet Status is required *"} />
                )}
                <br />
              </div>
              {toi && (
                <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                  <Label className="fs-4 title-font-500 mb-0 text-base-color">
                    No Of Toilet *
                  </Label>
                  <br />
                  <div className="mt-1  d-flex gap-3">
                    <input
                      className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                      type="text"
                      placeholder="No Of Toilet..."
                      {...register("no_of_toilet", { required: true })}
                    />
                  </div>
                  {errors.no_of_toilet && (
                    <ErrorComponents error={"No of Toilets is required *"} />
                  )}

                  <br />
                </div>
              )}
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Electric Supply *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="electricity_connection"
                    name="role_type"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("electricity_connection", { required: true })}
                  >
                    <option value="">Electric Supply</option>
                    {electricityconnection?.map((econnection, i) => {
                      return (
                        <option value={econnection.electricity_connection} key={i}>
                          {econnection.electricity_connection}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {errors.electricity_connection && (
                  <ErrorComponents error={"Electric Supply *required"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Service Number *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    placeholder="Service Number"
                    {...register("service_no", { required: true, onChange: (e) => { e.target.value = e.target.value.toUpperCase() } })}
                  />
                </div>
                {errors.service_no && (
                  <ErrorComponents error={"Service Number is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Electricity Deposit *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeValues}
                    placeholder="Electricity Deposit"
                    {...register("electricity_deposit", { required: true })}
                  />
                </div>
                {errors.electricity_deposit && (
                  <ErrorComponents error={"Electricity Deposit is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Meter Owner *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    placeholder="Meter Owner"
                    {...register("meter_owner", { required: true, onChange: (e) => isAlphaHandeler(e) })}
                  />
                </div>
                {errors.meter_owner && (
                  <ErrorComponents error={"Meter Owner is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  No Of Light *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeValues}
                    placeholder="No Of Light...."
                    {...register("no_of_light", { required: true })}
                  />
                </div>
                {errors.no_of_light && (
                  <ErrorComponents error={"No of length is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Date Of Completion *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="date"
                    placeholder="Date Of Completion..."
                    max={currentDate}
                    {...register("date_of_completion", { required: true })}
                    onChange={(e) => setDateOfCompletion(e.target.value)}
                  />
                </div>
                {errors.date_of_completion && (
                  <ErrorComponents error={"Date of completion is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Survey No *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input text-uppercase"
                    type="text"
                    placeholder="Survey No...."
                    {...register("survey_no", { required: true, onChange: (e) => { e.target.value = e.target.value.toUpperCase() } })}
                  />
                </div>
                {errors.survey_no && (
                  <ErrorComponents error={"Survey no is required *"} />
                )}
                <br />
              </div>

              {date_of_completion && (
                <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                  <Label className="fs-4 title-font-500 mb-0 text-base-color">
                    Building Age *
                  </Label>
                  <div className="mt-1  d-flex gap-3">
                    <Label className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white">
                      {`${yearsBetween} years, ${monthsBetween} months, ${daysBetween} days`}
                    </Label>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0 border-primary border-end my-3">
                <FormGroup
                  switch
                  className="mt-1  d-flex gap-3 align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center">
                    <span className="me-2">
                      <img className=" w-h-25" src={fireExtinguisher} alt="" />
                    </span>{" "}
                    <h5 className="fs-5  base-font-700 m-0"> Fire System</h5>
                  </div>
                  <div className="d-flex align-items-center gap-Box">
                    {showfire && <span className="" title="Certificate upload ">
                      <div className='mt-1 d-flex gap-3 align-items-center'>
                        <input
                          className=' fileinput'
                          type='file'
                          multiple
                          accept='image/jpeg,image/jpg,image/png,application/pdf'
                          placeholder='Upload Images...'
                          {...register("fire_system_document", {
                          })}
                        />
                        <div className=' btn border-base-color-1  bg-transparent flex-nowrap overflow-hidden px-3 py-1 d-flex justify-content-center align-items-center'>
                          <i className='bx bx-cloud-upload bx-flashing fs-1 text-base-color' ></i>
                        </div>
                      </div>
                      {errors.documenturl && <ErrorComponents error={'Image is required *'} />}
                    </span>}
                    <Controller
                      control={control}
                      name="fire_system"
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                      }) => (
                        <Input
                          type="switch"
                          role="switch"
                          className="px-4  border-radius-10 shadow-none  title-font-500 fs-2 modal-input"
                          onBlur={onBlur}
                          onChange={onChange}
                          inputRef={ref}
                          checked={value}
                        />
                      )}
                    />
                  </div>
                </FormGroup>
                {
                  showfire && firesystemdocument &&
                  <div className="row align-items-center justify-content-between gap-2 my-3">
                    {
                      Array.from(firesystemdocument).map((file, i) => {
                        return (
                          <div className="buttons p-3 mx-1  rounded-2" style={{
                            width:
                              "47%"
                          }} key={i}>
                            <h4 className="mb-0 base-font-500 fs-4 text-dotted"  >{file.name}</h4>
                          </div>
                        )
                      })
                    }
                  </div>
                }
                {showfire && <div className="mt-4 ">
                  <textarea
                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                    placeholder='Enter  Comments...'
                    {...register("fire_system_comment", { required: true })}
                  ></textarea>
                </div>}

                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0 border-primary border-end my-3">
                <FormGroup
                  switch
                  className="mt-1  d-flex gap-3 align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center">
                    <span className="me-2">
                      <img className=" w-h-25" src={policy} alt="" />
                    </span>{" "}
                    <h5 className="fs-5  base-font-700 m-0">
                      {" "}
                      Stability Certificate
                    </h5>
                  </div>
                  <div className="d-flex align-items-center gap-Box">
                    {sstability && <span className="" title="Certificate upload ">
                      <div className='mt-1 d-flex gap-3'>
                        <input
                          className='fileinput'
                          type='file'
                          multiple
                          accept="image/jpeg,image/jpg,image/png,application/pdf"
                          placeholder='Upload Images...'
                          {...register("stability_certificate_document")}
                        />
                        <div className=' btn border-base-color-1  bg-transparent flex-nowrap overflow-hidden px-3 py-1 d-flex justify-content-center align-items-center'>
                          <i className='bx bx-cloud-upload bx-flashing fs-1 text-base-color' ></i>
                        </div>
                      </div>
                      {errors.documenturl && <ErrorComponents error={'Image is required *'} />}
                    </span>}
                    <Controller
                      control={control}
                      name="stability_certificate"
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                      }) => (
                        <Input
                          type="switch"
                          role="switch"
                          className="px-4  border-radius-10 shadow-none  title-font-500 fs-2 modal-input"
                          onBlur={onBlur}
                          onChange={onChange}
                          inputRef={ref}
                          checked={value}
                        />
                      )}
                    />
                  </div>
                </FormGroup>
                {
                  sstability && stabilitycertificatedocument &&
                  <div className="row align-items-center justify-content-between gap-2 my-3">
                    {
                      Array.from(stabilitycertificatedocument).map((file, i) => {
                        return (
                          <div className="buttons p-3 mx-1  rounded-2" style={{
                            width:
                              "47%"
                          }} key={i}>
                            <h4 className="mb-0 base-font-500 fs-4 text-dotted"  >{file.name}</h4>
                          </div>
                        )
                      })
                    }
                  </div>
                }
                {sstability && <div className="mt-4 ">
                  <textarea
                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                    placeholder='Enter  Comments...'
                    {...register("stability_comment", { required: true })}
                  ></textarea>
                </div>}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0 border-primary  my-3">
                <FormGroup
                  switch
                  className="mt-1  d-flex gap-3 align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center">
                    <span className="me-2">
                      <img className=" w-h-25" src={solarEnergy} alt="" />
                    </span>{" "}
                    <h5 className="fs-5  base-font-700 m-0"> Solar Power</h5>
                  </div>
                  <div className="d-flex align-items-center gap-Box">
                    {ssolarpower && <span className="" title="Certificate upload ">
                      <div className='mt-1 d-flex gap-3'>
                        <input
                          className='fileinput'
                          type='file'
                          multiple
                          accept="image/jpeg,image/jpg,image/png,application/pdf"
                          placeholder='Upload Images...'
                          {...register("solar_power_document")}
                        />
                        <div className=' btn border-base-color-1  bg-transparent flex-nowrap overflow-hidden px-3 py-1 d-flex justify-content-center align-items-center'>
                          <i className='bx bx-cloud-upload bx-flashing fs-1 text-base-color' ></i>
                        </div>
                      </div>
                      {errors.documenturl && <ErrorComponents error={'Image is required *'} />}
                    </span>}
                    <Controller
                      control={control}
                      name="solar_power"
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                      }) => (
                        <Input
                          type="switch"
                          role="switch"
                          className="px-4  border-radius-10 shadow-none  title-font-500 fs-2 modal-input"
                          onBlur={onBlur}
                          onChange={onChange}
                          inputRef={ref}
                          checked={value}
                        />
                      )}
                    />
                  </div>
                </FormGroup>
                {
                  ssolarpower && solarpowerdocument &&
                  <div className="row align-items-center justify-content-between gap-2 my-3">
                    {
                      Array.from(solarpowerdocument).map((file, i) => {
                        return (
                          <div className="buttons p-3 mx-1  rounded-2" style={{
                            width:
                              "47%"
                          }} key={i}>
                            <h4 className="mb-0 base-font-500 fs-4 text-dotted"  >{file.name}</h4>
                          </div>
                        )
                      })
                    }
                  </div>}
                {
                  ssolarpower &&
                  <div className="mt-4 col-12">
                    <textarea
                      className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                      placeholder='Enter  Comments...'
                      {...register("solar_comment", { required: true })}
                    ></textarea>
                  </div>
                }
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0 border-primary border-end">
                <FormGroup
                  switch
                  className="mt-1  d-flex gap-3 align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center">
                    <span className="me-2">
                      <img className=" w-h-25" src={stairs} alt="" />
                    </span>{" "}
                    <h5 className="fs-5  base-font-700 m-0">
                      {" "}
                      Mazanine Facility
                    </h5>
                  </div>
                  <div className="d-flex align-items-center gap-Box">
                    {smazanine && <span className="" title="Certificate upload ">
                      <div className='mt-1 d-flex gap-3'>
                        <input
                          className='fileinput'
                          type='file'
                          multiple
                          accept="image/jpeg,image/jpg,image/png,application/pdf"
                          placeholder='Upload Images...'
                          {...register("mazanine_facility_document")}
                        />
                        <div className=' btn border-base-color-1  bg-transparent flex-nowrap overflow-hidden px-3 py-1 d-flex justify-content-center align-items-center'>
                          <i className='bx bx-cloud-upload bx-flashing fs-1 text-base-color' ></i>
                        </div>
                      </div>
                      {errors.documenturl && <ErrorComponents error={'Image is required *'} />}
                    </span>}
                    <Controller
                      control={control}
                      name="mazanine_facility"
                      render={({ field: { onChange, onBlur, value, name, ref },
                      }) => (
                        <Input
                          type="switch"
                          role="switch"
                          className="px-4  border-radius-10 shadow-none  title-font-500 fs-2 modal-input"
                          onBlur={onBlur}
                          onChange={onChange}
                          inputRef={ref}
                          checked={value}
                        />
                      )}
                    />
                  </div>
                </FormGroup>
                {
                  smazanine && mazaninefacilitydocument &&
                  <div className="row align-items-center justify-content-between gap-2 my-3">
                    {
                      Array.from(mazaninefacilitydocument).map((file, i) => {
                        return (
                          <div className="buttons p-3 mx-1  rounded-2" style={{
                            width:
                              "47%"
                          }} key={i}>
                            <h4 className="mb-0 base-font-500 fs-4 text-dotted"  >{file.name}</h4>
                          </div>
                        )
                      })
                    }
                  </div>}
                {
                  smazanine &&
                  <div className="mt-4 ">
                    <textarea
                      className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                      placeholder='Enter  Comments...'
                      {...register("mazanine_comment", { required: true })}
                    ></textarea>
                  </div>}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0 border-primary border-end">
                <FormGroup
                  switch
                  className="mt-1  d-flex gap-3 align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center">
                    <span className="me-2">
                      <img className=" w-h-25" src={contractNoc} alt="" />
                    </span>{" "}
                    <h5 className="fs-5  base-font-700 m-0"> NOC</h5>
                  </div>
                  <div className="d-flex align-items-center gap-Box">
                    {snoc &&
                      <span className="" title="Certificate upload ">
                        <div className='mt-1 d-flex gap-3'>
                          <input
                            className='fileinput'
                            type='file'
                            multiple
                            accept="image/jpeg,image/jpg,image/png,application/pdf"
                            placeholder='Upload Images...'
                            {...register("noc_document")}
                          />
                          <div className=' btn border-base-color-1  bg-transparent flex-nowrap overflow-hidden px-3 py-1 d-flex justify-content-center align-items-center'>
                            <i className='bx bx-cloud-upload bx-flashing fs-1 text-base-color' ></i>
                          </div>
                        </div>
                        {errors.documenturl && <ErrorComponents error={'Image is required *'} />}
                      </span>}
                    <Controller
                      control={control}
                      name="noc"
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                      }) => (<Input
                        type="switch"
                        role="switch"
                        className="px-4  border-radius-10 shadow-none  title-font-500 fs-2 modal-input"
                        onBlur={onBlur}
                        onChange={onChange}
                        inputRef={ref}
                        checked={value}
                      />
                      )}
                    />
                  </div>
                </FormGroup>
                {
                  snoc && nocdocument &&
                  <div className="row align-items-center justify-content-between gap-2 my-3">
                    {
                      Array.from(nocdocument).map((file, i) => {
                        return (
                          <div className="buttons p-3 mx-1  rounded-2" style={{
                            width:
                              "47%"
                          }} key={i}>
                            <h4 className="mb-0 base-font-500 fs-4 text-dotted"  >{file.name}</h4>
                          </div>
                        )
                      })
                    }
                  </div>}
                {
                  snoc &&
                  <div className="mt-4 ">
                    <textarea
                      className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                      placeholder='Enter  Comments...'
                      {...register("noc_comment", { required: true })}
                    ></textarea>
                  </div>}
                <br />
              </div>


              <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                <FormGroup
                  switch
                  className="mt-1  d-flex gap-3 align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center">
                    <span className="me-2">
                      <img className=" w-h-25" src={contractNoc} alt="" />
                    </span>{" "}
                    <h5 className="fs-5  base-font-700 m-0"> Electricity</h5>
                  </div>
                  <div className="d-flex align-items-center gap-Box">
                    {electricity &&
                      <span className="" title="Certificate upload ">
                        <div className='mt-1 d-flex gap-3'>
                          <input
                            className='fileinput'
                            type='file'
                            multiple
                            accept="image/jpeg,image/jpg,image/png,application/pdf"
                            placeholder='Upload Images...'
                            {...register("electricity_document")}
                          />
                          <div className=' btn border-base-color-1  bg-transparent flex-nowrap overflow-hidden px-3 py-1 d-flex justify-content-center align-items-center'>
                            <i className='bx bx-cloud-upload bx-flashing fs-1 text-base-color' ></i>
                          </div>
                        </div>
                        {errors.documenturl && <ErrorComponents error={'Image is required *'} />}
                      </span>}
                    <Controller
                      control={control}
                      name="electricity"
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                      }) => (<Input
                        type="switch"
                        role="switch"
                        className="px-4  border-radius-10 shadow-none  title-font-500 fs-2 modal-input"
                        onBlur={onBlur}
                        onChange={onChange}
                        inputRef={ref}
                        checked={value}
                      />
                      )}
                    />
                  </div>
                </FormGroup>
                {
                  selectricity && electricitydoc &&
                  <div className="row align-items-center justify-content-between gap-2 my-3">
                    {
                      Array.from(electricitydoc).map((file, i) => {
                        return (
                          <div className="buttons p-3 mx-1  rounded-2" style={{
                            width:
                              "47%"
                          }} key={i}>
                            <h4 className="mb-0 base-font-500 fs-4 text-dotted"  >{file.name}</h4>
                          </div>
                        )
                      })
                    }
                  </div>}
                {
                  selectricity &&
                  <div className="mt-4 ">
                    <textarea
                      className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                      placeholder='Enter  Comments...'
                      {...register("electricity_comment", { required: true })}
                    ></textarea>
                  </div>}
                <br />
              </div>
            </div>
            {
              props.button != "create" && builddocs?.length != 0 &&
              <div className="bg-white p-5 d-flex gap-5 flex-column rounded-5 mt-5">
                <div className="d-flex justify-content-between align-items-center">
                  <h1 className="title-font-bold ">Documents</h1>
                </div>
                <DocumentsCard documentDetails={builddocs} building={true} handle={handleDocument} />
              </div>
            }
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              className="border-radius-7 p-3 d-flex align-items-center buttons-outline"
              onClick={CancelButton}
            >
              <span className="fs-5 d-flex gap-3 title-font-600 px-3">
                Cancel
              </span>
            </Button>{" "}
            <Button
              className="border-radius-7 p-3 d-flex align-items-center buttons"
              disabled={!btndis || errormessage || carpetErrorMessage}
            >
              <span className="fs-5 d-flex gap-3 title-font-600 px-3">
                {props.button == "create"
                  ? "Create"
                  : `Save`}
              </span>
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}
export default BuildingModal;
